import * as PopoverPrimitive from "@radix-ui/react-popover";
import React from "react";

const Popover = (props: {
  children: React.ReactNode;
  content: () => React.ReactNode;
  align?: "center" | "start" | "end";
  sideOffset?: number;
  side?: "top" | "right" | "bottom" | "left";
  modal?: boolean;
  closeButton?: React.ReactNode;
}) => {
  return (
    <PopoverPrimitive.Root modal={props.modal}>
      <PopoverPrimitive.Trigger asChild>
        {props.children}
      </PopoverPrimitive.Trigger>
      <PopoverPrimitive.Content
        side={props.side}
        asChild
        align={props.align}
        sideOffset={props.sideOffset == null ? 8 : props.sideOffset}
      >
        {props.content()}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Root>
  );
};

export default Popover;
